/**
 * Estilos do FiltroExcel (barra de filtros no padrão Excel).
 * Promovidos de GestaoSolicitacoes/styles.jsx para uso em qualquer tela.
 */
import styled from "styled-components";

export { default as Checkbox } from "../Checkbox";

export const FexBar = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
`;

export const FexWrap = styled.div`
  position: relative;
`;

export const FexBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 10px;
  border-radius: 8px;
  border: 1px solid
    ${({ $ativo }) => ($ativo ? "var(--accent)" : "var(--border)")};
  background: ${({ $ativo }) =>
    $ativo ? "var(--accent-soft)" : "var(--surface)"};
  color: ${({ $ativo }) => ($ativo ? "var(--accent)" : "var(--ink-2)")};
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    border-color: var(--accent);
  }
`;

export const FexBadge = styled.span`
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  background: var(--accent);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  display: inline-grid;
  place-items: center;
`;

export const FexPanel = styled.div`
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  z-index: 60;
  min-width: 250px;
  max-width: 320px;
  background: var(--surface);
  border: 1px solid var(--border-strong, var(--border));
  border-radius: 10px;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.16);
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const FexSearch = styled.input`
  margin: 8px;
  height: 30px;
  padding: 0 10px;
  border: 1px solid var(--border);
  border-radius: 7px;
  background: var(--bg);
  color: var(--ink);
  font-size: 12.5px;

  &:focus {
    outline: none;
    border-color: var(--accent);
  }
`;

export const FexLista = styled.div`
  max-height: 280px;
  overflow-y: auto;
  padding: 0 4px 4px;
`;

export const FexOpcao = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  border-radius: 6px;
  font-size: 12.5px;
  color: var(--ink);
  cursor: pointer;

  &:hover {
    background: var(--surface-hover, var(--bg));
  }
  .txt {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &[data-tudo="1"] {
    font-weight: 700;
    border-bottom: 1px solid var(--border);
    border-radius: 6px 6px 0 0;
  }
`;

export const FexCount = styled.span`
  font-size: 11px;
  color: var(--ink-3);
  font-variant-numeric: tabular-nums;
`;

export const FexFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding: 8px;
  border-top: 1px solid var(--border);

  button {
    border: 0;
    background: none;
    color: var(--accent);
    font-size: 12.5px;
    font-weight: 600;
    cursor: pointer;
    padding: 4px 6px;
    border-radius: 6px;
  }
  button:hover {
    background: var(--accent-soft);
  }
  button:disabled {
    color: var(--ink-4);
    cursor: default;
    background: none;
  }
`;

export const FexVazio = styled.div`
  padding: 14px 10px;
  font-size: 12px;
  color: var(--ink-3);
  text-align: center;
`;

export const FexChipsRow = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
  flex-wrap: wrap;
`;

export const FexChip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  max-width: 340px;
  padding: 3px 6px 3px 10px;
  border-radius: 999px;
  background: var(--accent-soft);
  color: var(--accent);
  font-size: 12px;
  font-weight: 600;

  .vals {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  button {
    border: 0;
    background: none;
    color: inherit;
    cursor: pointer;
    display: grid;
    place-items: center;
    padding: 2px;
    border-radius: 999px;
  }
  button:hover {
    background: rgba(0, 0, 0, 0.08);
  }
`;
